import { UrlMaker } from 'src/app/commons/url-maker';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TbAuthService } from '@tb/auth';
import { LoginService } from './login.service';

@Injectable({ providedIn: 'root' })
export class HelpService {
    storeApiUrl: string;
    helpCenterApiUrl: string;
    constructor(private loginService: LoginService, private http: HttpClient, private tbAuthService: TbAuthService) {
        this.storeApiUrl = environment.settings.storeApiUrl;
        this.helpCenterApiUrl = environment.settings.helpCenterApiUrl;
    }
    
    openHelpCenter(language: string): void {
        let authorization = JSON.stringify({
            type: "jwt",
            appId: "ST",
            securityValue: this.loginService.getAuthInfoProperties().jwtEncoded
        });

        let url = new UrlMaker()
            .appendBaseUrl(this.helpCenterApiUrl)
            .appendSegment('Login.aspx')
            .appendParameter('accountName', this.tbAuthService.getAccountName())
            .appendParameter('auth', authorization)
            .appendParameter('Language', language)
            .appendParameter('Namespace', 'MainPage')
            .toString();
        window.open(url);
    }
}
